/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Request_Data_LabelInputs */

const en_platform_request_data_label = /** @type {(inputs: Platform_Request_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request new data`)
};

const zh_hans1_platform_request_data_label = /** @type {(inputs: Platform_Request_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申请新数据`)
};

const pt_br2_platform_request_data_label = /** @type {(inputs: Platform_Request_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedir novos dados`)
};

const es_platform_request_data_label = /** @type {(inputs: Platform_Request_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar datos nuevos`)
};

const fr_platform_request_data_label = /** @type {(inputs: Platform_Request_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demander de nouvelles données`)
};

const de_platform_request_data_label = /** @type {(inputs: Platform_Request_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Daten anfragen`)
};

const ru_platform_request_data_label = /** @type {(inputs: Platform_Request_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросить новые данные`)
};

const it_platform_request_data_label = /** @type {(inputs: Platform_Request_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiedi nuovi dati`)
};

/**
* | output |
* | --- |
* | "Request new data" |
*
* @param {Platform_Request_Data_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_request_data_label = /** @type {((inputs?: Platform_Request_Data_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Request_Data_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_request_data_label(inputs)
	if (locale === "pt-BR") return pt_br2_platform_request_data_label(inputs)
	if (locale === "es") return es_platform_request_data_label(inputs)
	if (locale === "fr") return fr_platform_request_data_label(inputs)
	if (locale === "de") return de_platform_request_data_label(inputs)
	if (locale === "ru") return ru_platform_request_data_label(inputs)
	if (locale === "it") return it_platform_request_data_label(inputs)
	return en_platform_request_data_label(inputs)
});